import { useNavigate, useSearchParams } from 'react-router'
import { useTranslation } from 'react-i18next'
import { useClientLang } from '~/utils/i18n.utils'
import { capitalizeText } from '~/utils/misc'
import type { CountryList } from '~/queries/getCountryList.server'
import {
	clearSearchPlaceParams,
	searchBoxFilterStyle,
} from './searchbox.helper'
import type { UserLocation } from '~/types/location'

export default function SearchBoxCountrySelect({
	countries,
	userLocation,
}: {
	countries: CountryList[]
	userLocation: UserLocation
}) {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const lang = useClientLang().lngShort
	const [searchParams] = useSearchParams()

	// Create search params without location specific params
	const sp = clearSearchPlaceParams(searchParams)

	return (
		<div className="inline-block w-full" key="country-select">
			<select
				className={searchBoxFilterStyle}
				onChange={e => {
					navigate(
						`${lang === 'sv' ? '' : `/${lang}`}/place/${e.target.value.toLowerCase()}${
							sp.size > 0 ? '?' + sp.toString() : ''
						}`,
					)
				}}
				value={userLocation.countryCode?.toLowerCase() || ''}
				aria-label={t('misc_country')}
			>
				<option value={''}>{t('public_everywhere')}</option>
				{countries.map(country => (
					<option key={country.countryCode} value={country.countryCode}>
						{capitalizeText(country.country)}
					</option>
				))}
			</select>
		</div>
	)
}
